<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="carUseStatic">
            <van-nav-bar
                title="车辆使用情况统计"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <div class="top-wrapper">
                <div class="select-wrapper">
                    <div class="select-item">
                        <div @click="showTimePicker(0)">
                            <span>{{ startTimeValue }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                        <div @click="showTimePicker(1)">
                            <span>{{ endTimeValue }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                    </div>
                    <div
                        class="select-item"
                        @click="showStation = true"
                    >
                        <span>{{ stationName }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                </div>
            </div>
            <div class="view-data">
                <div class="item">
                    <div class="ins">
                        <span>场站车辆(l辆)</span><p>{{ stationVehicleTotal }}</p>
                    </div>
                    <div class="ins">
                        <span>累计方量(方)</span><p>{{ stationVolumeTotal }}</p>
                    </div>
                </div>
                <div class="item">
                    <div class="ins">
                        <span>运营车辆(l辆)</span><p>{{ operateVehicleTotal }}</p>
                    </div>
                    <div class="ins">
                        <span>累计方量(方)</span><p>{{ operateVolumeTotal }}</p>
                    </div>
                </div>
                <div class="item">
                    <div class="ins">
                        <span>闲置车辆(l辆)</span><p>{{ vacantVehicleTotal }}</p>
                    </div>
                    <div class="ins">
                        <span>累计方量(方)</span><p>-</p>
                    </div>
                </div>
            </div>
            <div class="view-list">
                <van-tabs title-active-color="#E40002" background="#F0F0F0">
                    <van-tab title="运营车辆">
                        <ul class="list">
                            <li v-for="item in operateList" :key="item.plateNumber">
                                <div class="col">
                                    <span>车牌号</span>
                                    <p>{{ item.plateNumber }}</p>
                                </div>
                                <div class="col">
                                    <span>运载次数(次)</span>
                                    <p>{{ item.transportNumber }}</p>
                                </div>
                                <div class="col">
                                    <span>累计运输方量(方)</span>
                                    <p>{{ item.transportVolumeTotal }}</p>
                                </div>
                            </li>
                            <van-empty v-if="operateList.length==0" description="暂无数据"></van-empty>
                        </ul>
                    </van-tab>
                    <van-tab title="闲置车辆">
                        <ul class="list">
                            <li v-for="item in spareList" :key="item.plateNumber">
                                <div class="col">
                                    <span>车牌号</span>
                                    <p>{{ item.plateNumber }}</p>
                                </div>
                                <div class="col use-time">
                                    <span>上次使用时间</span>
                                    <p>{{ item.lastUsageTime }}</p>
                                </div>
                            </li>
                            <van-empty v-if="spareList.length==0" description="暂无数据"></van-empty>
                        </ul>
                    </van-tab>
                </van-tabs>
            </div>
            <!-- 选择场站 -->
            <van-popup
                v-model="showStation"
                position="bottom"
            >
                <van-picker
                    show-toolbar
                    :columns="stationList"
                    value-key="name"
                    @cancel="showStation = false"
                    @confirm="onConfirm"
                ></van-picker>
            </van-popup>
            <!-- 选择时间-->
            <van-popup
                v-model="timePicker"
                position="bottom"
                :overlay="true"
            >
                <van-datetime-picker
                    v-model="timeDate"
                    type="date"
                    title="选择年月日"
                    @confirm="confirmDate"
                    @cancel="timePicker = false"
                ></van-datetime-picker>
            </van-popup>
            <van-loading
                class="pageLogin"
                v-show="loading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
        </div>
    </v-touch>
</template>

<script>
import utils from '@/assets/js/utils';
export default {
    name: 'car-use-static',
    data() {
        return {
            loading: false,
            showStation: false,

            timePicker: false,
            timeType: 0,
            timeDate: '',
            startTimeValue: '',
            endTimeValue: '',

            stationId: '',
            stationName: '',
            // 场站数据集
            stationList: [{
                station_id: '',
                name: '全部',
            }],


            stationVehicleTotal: 0, // 场站车辆
            stationVolumeTotal: 0, // 场站累计方量
            operateVehicleTotal: 0, // 运营车辆
            operateVolumeTotal: 0, // 运营累计方量
            vacantVehicleTotal: 0, // 空闲车辆

            operateList: [], // 运营车辆
            spareList: [], // 空闲车辆
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            const date = new Date();
            this.startTimeValue = utils.timeFormat(new Date(date.getFullYear(), date.getMonth()), 'yyyy-MM-dd');
            this.endTimeValue = utils.currentTimeFormat('yyyy-MM-dd');
            this.stationName = this.stationList[0].name;
            this.getData();
            this.getStationList();
        },
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 显示时间控件
        showTimePicker(num) {
            if (num === 0) {
                this.timeDate = new Date(this.startTimeValue);
            } else {
                this.timeDate = new Date(this.endTimeValue);
            }
            this.timeType = num;
            this.timePicker = true;
        },
        // 确认时间
        confirmDate(date) {
            if (this.timeType === 0) {
                this.startTimeValue = utils.timeFormat(date, 'yyyy-MM-dd');
            } else {
                this.endTimeValue = utils.timeFormat(date, 'yyyy-MM-dd');
            }
            this.timePicker = false;
            this.getData();
        },

        // 场站确认选择
        onConfirm(item) {
            this.stationId = item.station_id;
            this.stationName = item.name;
            this.showStation = false;
            this.getData();
        },
        // 获取当前页面数据
        getData() {
            this.loading = true;
            const url = '/interfaceApi/production/vehicleinfo/get_vehicle_usage_statistics?beginTime='
                + this.startTimeValue + '&endTime=' + this.endTimeValue + '&mixstationCode=' + this.stationId;
            this.$axios.get(url).then(data => {
                this.stationVehicleTotal = data.stationVehicleTotal;
                this.stationVolumeTotal = data.stationVolumeTotal;
                this.operateVehicleTotal = data.operateVehicleTotal;
                this.operateVolumeTotal = data.operateVolumeTotal;
                this.vacantVehicleTotal = data.vacantVehicleTotal;
                this.operateList = data.operateVehicleUsageList || [];
                this.spareList = data.vacantVehicleUsageList || [];
                this.loading = false;
            });
        },
        // 获取场站列表
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationList.push(...stationList);
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.carUseStatic
    .top-wrapper
        background #ffffff
        padding 10rpx
        .select-wrapper
            height 45rpx
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
            border-radius 8px
            display flex
            .select-item
                flex 1
                text-align center
                span
                    font-size 14rpx
                    line-height 45rpx
                i
                    color #979EA7
                &:last-child
                    span
                        color #3495FB
                        padding-left 20rpx
                        border-left 2rpx solid #D7D7D7
                &:first-child
                    flex 2
                    display flex
                    div
                        flex 1
                    p
                        line-height 45rpx
                        color #979EA7
                        font-weight 600
        .statistics-head
            background #ffffff
            display flex
            padding 10rpx
            margin-top 10rpx
            div
                flex 1
                text-align center
                &.month-count
                    span
                        color #FA8436
                        font-size 16rpx
                &.year-count
                    span
                        color #5588F1
                        fonts-size 16rpx
                p
                    font-size 10rpx
                    color #666666
                    line-height 20rpx
    .view-data
        padding 15rpx;
        display flex
        justify-content space-between
        .item
            width: 105rpx;
            height: 114rpx;
            background: rgba(250, 132, 54, 0.06);
            border-radius: 4rpx;
            &:nth-child(1)
                background: rgba(250, 132, 54, 0.06);
                color #FA8436
                .ins:nth-child(1)
                    border-bottom: 1px dashed #FFE4D1;
            &:nth-child(2)
                background: rgba(85, 136, 241, 0.06);
                color #5588F1
                .ins:nth-child(1)
                    border-bottom: 1px dashed #E0EAFF;
            &:nth-child(3)
                background: rgba(33, 189, 204, 0.06);
                color #21BDCC
                .ins:nth-child(1)
                    border-bottom: 1px dashed #C6EFF3;
            .ins
                box-sizing border-box
                padding-left 15rpx;
                padding-top 9rpx;
                width 100%;
                height 50%;
                font-size 12rpx;
                span
                    color #979EA7
                p
                    margin-top 2rpx;
                    font-size 21rpx;
    .view-list
        .list
            box-sizing border-box
            height calc(100vh - 300rpx)
            padding 17rpx;
            overflow-y auto
            li
                margin 8rpx 0;
                padding 0 15rpx;
                width: 100%;
                height: 60rpx;
                background: #FFFFFF;
                border: 1px solid #E8E8E8;
                display flex
                align-items center
                flex 1
                .col
                    width 33%
                    &:nth-child(1)
                        span
                            color #666666
                        p
                            font-size #333333
                            font-weight bold
                    &:nth-child(2)
                    &:nth-child(3)
                        color #5588F1
                    &.use-time
                        color #21BDCC
                    span
                        padding 1px 3rpx;
                        background: #F0F0F0;
                        font-size 12rpx;
                    p
                        margin-top 5rpx;
                        font-size 14rpx;
</style>
